import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  "data-slot": "icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 5h4m0 0h4a7.997 7.997 0 0 1-4 6.93M7 5V3m0 8.93A7.963 7.963 0 0 1 3 13m4-1.07A8.039 8.039 0 0 1 4.07 9M7 11.93A7.963 7.963 0 0 0 11 13m10 8v-.063c0-.993-.105-1.977-.31-2.937M13 21v-.063c0-.993.105-1.977.31-2.937m0 0a14.076 14.076 0 0 1 2.774-5.855 1.173 1.173 0 0 1 1.832 0A14.076 14.076 0 0 1 20.69 18m-7.38 0h7.38"
    }, null, -1)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "translate"}) } }